import { render, staticRenderFns } from "./yjList.vue?vue&type=template&id=0575f59a&scoped=true&"
import script from "./yjList.vue?vue&type=script&lang=js&"
export * from "./yjList.vue?vue&type=script&lang=js&"
import style0 from "./yjList.vue?vue&type=style&index=0&id=0575f59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0575f59a",
  null
  
)

export default component.exports